'use strict'

/**
 * Choices reads an option's text to build its label, so markup meant to be
 * rendered has to be smuggled through as text. A bare text node is not safe:
 * on block themes WordPress runs wptexturize() over the rendered page, which
 * curls the quotes in src="..." into src=”...” and breaks every URL. Markup is
 * therefore emitted in data-label-html, which sits inside a tag where
 * wptexturize() never looks, and is moved back into the option here.
 *
 * Options without the attribute are left untouched.
 */
function apply_choices_label_html(select) {
	select?.querySelectorAll?.('option[data-label-html]').forEach((option) => {
		option.textContent = option.dataset.labelHtml;
	});
}

function get_single_select_choices_options(select, choices_additional_args){
	try {
		const choicesOptions = {
			shouldSortItems: false,
			allowHTML: true,
			noResultsText: wp.i18n.__("No results found", "levcharity"),
			callbackOnCreateTemplates: function (template, escapeForTemplate, getClassNames) {
				if(typeof getClassNames !== 'function') {
					return template;
				}

				return {
					item: ({classNames}, data) => {
						return template(`
							<div
								class="${getClassNames(classNames.item).join(' ')} ${getClassNames(data.highlighted ? classNames.highlightedState : classNames.itemSelectable).join(' ')} ${data.placeholder ? classNames.placeholder : ''}"
								data-item
								data-id="${data.id}"
								data-value="${data.value}"
								data-select-text="${this.config?.itemSelectText || ''}"
								${data.active ? 'aria-selected="true"' : ''}
								${data.disabled ? 'aria-disabled="true"' : ''}
							>
								 ${data.label}
							</div>
						`);
					}, choice: ({classNames}, data) => {
						return template(`
							<div
								class="${getClassNames(classNames.item).join(' ')} ${getClassNames(classNames.itemChoice).join(' ')} ${getClassNames(data.disabled ? classNames.itemDisabled : classNames.itemSelectable).join(' ')}"
								data-select-text="${this.config?.itemSelectText || ''}"
								data-choice ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'}
								data-id="${data.id}"
								data-value="${data.value.replace(/\D/g, '')}"
								data-currency="${data.element.dataset.currency}"
								${data.groupId > 0 ? 'role="treeitem"' : 'role="option"'}
								>
								 ${data.label}
							</div>
						`);
					},
				};
			},
			searchEnabled: select.dataset.search !== 'false',
			itemSelectText: select.dataset.placeholder,
			...choices_additional_args,
		}

		if (select.placeholder) {
			choicesOptions.placeholder = true;
			choicesOptions.placeholderValue = select.placeholder;
		}

		return choicesOptions
	} catch ( error ) {
		console.error( error.message );
	} finally {
	}
}

export {
	apply_choices_label_html,
	get_single_select_choices_options
}

